export default __webpack_public_path__ + "static/media/NomadCamp.996a4867.jpg";